module.exports = __webpack_public_path__ + "static/media/Vox.a82ec73d.png";